export const getSelectedRowsByKeys = <DataSourceType extends { key: string | number }>(
  keys: Array<string | number>,
  dataSource?: DataSourceType[]
): DataSourceType[] | undefined => {
  const keysMap = keys.reduce((map, key) => {
    map.set(key, key)
    return map
  }, new Map<string | number, string | number>())

  return dataSource?.filter(dataSourceItem => keysMap.has(dataSourceItem.key))
}
